import React from 'react';
import { useSelector } from 'react-redux';
/** import third-party libraries in the section above, keep the ascending order */

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Typography from '@mui/material/Typography';
/** import mui components in the section above, keep the ascending order */

import { canUseReportJobs } from '../permissions';
import { useReportJobs } from '../hook';
import ReportJobList from '../report-job-list';
/** import classes and others in the section above, keep the ascending order */

/** Lists unsaved business report exports on `/reports`; hidden without sidebar Reports access. */
function UnsavedReportJobs() {
    const { unSavedReports } = useReportJobs();
    const globalRole = useSelector(state => state.profile.globalRole);
    const mayLoadReportJobs = canUseReportJobs(globalRole);

    if (!mayLoadReportJobs) {
        return null;
    }

    if (unSavedReports.length > 0) {
        return (
            <Box mb={2}>
                <Typography variant="h6">My Unsaved Reports</Typography>
                <Box mb={2}>
                    <Typography variant="caption" color="textSecondary">
                        Save your reports to keep them after 07 days.
                    </Typography>
                </Box>
                <TableContainer component={Paper}>
                    <ReportJobList reportJobs={unSavedReports} />;
                </TableContainer>
            </Box>
        );
    } else {
        return null;
    }
}
export default UnsavedReportJobs;
